export const faqDataIDVerify = [
  {
    id: 1,
    question: "Qu'est-ce qu'ID Verify ?",
    answer: "ID Verify est un outil de vérification d'identité en ligne utilisé dans le domaine bancaire, qui vous permet de confirmer l'authenticité d'un document d'identité ou d'une personne avant toute interaction, transaction ou échange sensible. Il est utilisé pour réduire les risques d'usurpation d'identité et de fraude."
  },
  {
    id: 2,
    question: "Pourquoi vérifier une identité avant d'interagir ?",
    answer: "Une vérification préalable réduit les risques de : fraude financière, usurpation d'identité, transactions non autorisées, partage de données sensibles avec des tiers malveillants."
  },
  {
    id: 3,
    question: "Comment fonctionne ID Verify ?",
    answer: "ID Verify analyse les informations fournies pour déterminer si une identité est authentique :\n\n1. Analyse du document (via photo, scan ou vidéo) : passeport, carte d'identité, titre de séjour ou permis de conduire.\n\n2. Vérification des données : nom, prénom, email et numéro de téléphone peuvent être analysés pour évaluer la cohérence de l'identité.\n\n3. Résultat fiabilité : vous obtenez une indication claire qui facilite votre prise de décision avant de poursuivre un échange ou une transaction."
  },
  {
    id: 4,
    question: "Quels documents puis-je vérifier avec ID Verify ?",
    answer: "Avec ID Verify, vous pouvez vérifier :\n\n• Passeport\n• Carte nationale d'identité\n• Titre de séjour\n• Permis de conduire (format carte bancaire)\n\nCes vérifications se font à partir d'une photo, d'un scan ou d'un enregistrement vidéo sécurisé."
  },
  {
    id: 5,
    question: "Puis-je vérifier une identité à partir des coordonnées d'une personne ?",
    answer: "Oui. ID Verify peut aussi analyser les données associées à une personne (comme son nom, son numéro de téléphone ou son email) pour obtenir un indicateur de fiabilité avant tout échange sensible."
  },
  {
    id: 6,
    question: "Combien de vérifications puis-je faire ?",
    answer: "Vous disposez de 3 vérifications gratuites par mois et par outil. Au-delà, chaque vérification est décomptée de votre solde. Vous pouvez acheter des packs de vérifications adaptés à vos besoins."
  },
];


export const faqDataIDTracker = [
  {
    id: 1,
    question: "Comment fonctionne ID Tracker ?",
    answer: "Si votre identité est utilisée dans notre réseau de partenaires pour ouvrir un compte bancaire ou effectuer une demande de financement, vous recevez immédiatement une notification via l'application mobile ID Protect.\n\nVous pouvez alors :\n\n- Autoriser l'utilisation de votre identité si la demande vient bien de vous\n\n- Refuser l'opération si vous n'êtes pas à l'origine de la démarche\n\nCe système de validation en temps réel vous permet de garder le contrôle total sur l'usage de votre identité."
  },
  {
    id: 2,
    question: "ID Tracker surveille-t-il le Dark Web ?",
    answer: "Oui, si vous avez souscrit à l'offre ID Tracker Sérénité ou ID Tracker Famille.\n\nDans ce cadre, nous effectuons une surveillance du Dark Web concernant :\n\n- Votre carte d'identité\n\n- Vos données personnelles associées\n\nSi une exposition est détectée, vous recevez une alerte afin de prendre rapidement les mesures nécessaires pour vous protéger."
  },
  {
    id: 3,
    question: "Quels documents puis-je protéger avec ID Tracker ?",
    answer: "ID Tracker vous permet de surveiller et tracer l'utilisation de vos principaux documents d'identité :\n\n- Carte nationale d'identité\n\n- Passeport\n\n- Titre de séjour\n\n- Permis de conduire (format carte uniquement)\n\nVous êtes également alerté si votre adresse email ou votre numéro de téléphone est utilisé auprès de nos partenaires."
  },
  {
    id: 4,
    question: "Quelle est la différence entre mettre en opposition et verrouiller un document ?",
    answer: "Mettre en opposition signifie que votre document d'identité devient définitivement inutilisable au sein de notre réseau de partenaires. Cette action est irréversible.\n\nVerrouiller un document permet de bloquer son utilisation de manière temporaire. C'est particulièrement utile si vous avez un doute (perte possible, suspicion de vol).\n\nVous pouvez déverrouiller votre document à tout moment depuis votre application."
  }
];